// Divide o total igualmente entre as linhas do rateio, em centavos: os centavos
// que sobram da divisão vão pra última linha, pra soma fechar exato com o total
// (é o que o 'rateio-fecha' do schema cobra). O percentual segue a mesma regra.
export const distributeEqually = (total: number, parts: number) => {
  if (parts <= 0) return []

  const totalCents = Math.round(total * 100)
  const baseCents = Math.floor(totalCents / parts)
  const basePercentage = Math.floor(10000 / parts) / 100

  return Array.from({ length: parts }, (_, index) => {
    const isLast = index === parts - 1
    return {
      amount: (isLast ? totalCents - baseCents * (parts - 1) : baseCents) / 100,
      percentage: isLast
        ? Number((100 - basePercentage * (parts - 1)).toFixed(2))
        : basePercentage
    }
  })
}
